// extracted by mini-css-extract-plugin
export default {"Switch":"Switch_Switch__opKOo","fullSize":"Switch_fullSize__iT3rg"};